import * as Globals from "../../globals";
import {Line} from "../baseElements/line";
import {Euler, Vector3} from "three";
import {createGroup} from "../../utils/threeUtils";
import {Text} from "../baseElements/text";
import {toFixedFloat} from "../../utils/utils";
import {setObjectLayer} from "../../utils/layerUtils";
import {render} from "../../sceneManager";
import {createHelpLines, createHelpLineCircles} from '../../utils/pointerUtils'

const dimensionBaseLineOverhang = 0.1;
const defaultHelpLineLength = 0.4;
const defaultHelpLineCircleDiameter = 0.05;
const defaultCircleLineThickness = 0.01;
const defaultDimensionTextToBaseLineOffset = 0.05;
const defaultSmallDimensionZOffset = 0.1;
const defaultFontSize = 0.15;
const defaultLineThickness = 0.01;

export class Dimension {
    /*
    * Hilfslinien (helpLine): Verlaufen vertikal zur Maßlinie. Defaultlänge 0.4 (0.1 davon oberhalb der Maßlinie, 0.3 unterhalb)
    * Maßpfeil (helplineCircle): Kreise die auf den Schnittpunkt jeder Hilfslinie und der Maßlinie sitzen. Durchmesser = helpLineCircleDiameter
    * */
    constructor(points, zOriented = false, scaleFactor = 1, helpLineLength = defaultHelpLineLength, helpLineCircleDiameter = defaultHelpLineCircleDiameter) {
        //TODO: Muss angepasst werden. Z Ausgerichtete Bemaßungen sind sonst verkehrt gespiegelz in Z Richtung
        if (zOriented) {
            for (let i = 0; i < points.length; i++) {
                points[i] = points[i] * -1;
            }

            points = points.reverse();
        }

        this.scaleFactor = scaleFactor;
        this.points = points; //Sortierte Liste aller 1D Koordinaten durch die, die Bemaßung verläuft
        this.group = createGroup("dimensionGroup");
        this.helpLineCircleDiameter = helpLineCircleDiameter * this.scaleFactor;
        this.dimensionTexts = [];
        this.lineThickness = defaultLineThickness * this.scaleFactor;
        this.circleLineThickness = defaultCircleLineThickness * this.scaleFactor;

        this.createDimensionTexts();
        this.createDimensionBaseLines();

        createHelpLines(this.points, this.group, helpLineLength, this.lineThickness);
        createHelpLineCircles(this.points, this.group, this.helpLineCircleDiameter, this.circleLineThickness);

        return this.group;
    }

    createDimensionTexts() {
        let fontSize = defaultFontSize * this.scaleFactor;
        for (let i = 0; i <= this.points.length - 2; i++) {
            let length = toFixedFloat(Math.abs(this.points[i + 1] - this.points[i]));
            let center = this.points[i] + (0.5 * length);
            let text;
            if (length > 0.1) {
                if (Number.isInteger(length)) {
                    length = length.toFixed(2);
                }
                text = new Text(length.toString(), fontSize, "center", "middle", new Vector3(center, 0, 0), new Euler(-Math.PI / 2, 0, 0), null, 0x000000, false);
            } else {
                length *= 100;
                length = toFixedFloat(length, 0);
                text = new Text(length.toString(), fontSize, "center", "bottom", new Vector3(center, 0, -defaultSmallDimensionZOffset), new Euler(-Math.PI / 2, 0, 0), null, 0x000000, false);
            }

            this.dimensionTexts.push(text);
            this.group.addWithUuid(text);
        }
    }

    createDimensionBaseLines() {
        for (let i = 0; i <= this.points.length - 2; i++) {
            let text = this.dimensionTexts[i];

            text.sync(() => {
                let length = toFixedFloat(this.points[i + 1] - this.points[i]);

                let startLeft = this.points[i];
                if (i === 0) {
                    startLeft -= dimensionBaseLineOverhang;
                }

                let endRight = this.points[i + 1];
                if (i === this.points.length - 2) {
                    endRight += dimensionBaseLineOverhang;
                }
                if (length > 0.1) {
                    let textBounds = text._textRenderInfo.visibleBounds;
                    let baseLineLeft = new Line(new Vector3(startLeft, 0, 0), new Vector3(textBounds[0] + text.position.x - defaultDimensionTextToBaseLineOffset, 0, 0), this.lineThickness);
                    this.group.addWithUuid(baseLineLeft);

                    let baseLineRight = new Line(new Vector3(textBounds[2] + text.position.x + defaultDimensionTextToBaseLineOffset, 0, 0), new Vector3(endRight, 0, 0), this.lineThickness);
                    this.group.addWithUuid(baseLineRight);
                } else {
                    let baseLine = new Line(new Vector3(startLeft, 0, 0), new Vector3(endRight, 0, 0), this.lineThickness);
                    this.group.addWithUuid(baseLine);
                }

                setObjectLayer(this.group, Globals.layers.measurements, true);
                if (i === this.points.length - 2) {
                    render();
                }
            });
        }
    }
}
